<template>
    <div class="activity-indicator-facebook">
        <div class="activity-indicator-facebook-rect1" />
        <div class="activity-indicator-facebook-rect2" />
        <div class="activity-indicator-facebook-rect3" />
        <div class="activity-indicator-facebook-rect4" />
        <div class="activity-indicator-facebook-rect5" />
    </div>
</template>